
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["operation_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M287.695 433.981h97.524v97.524h-97.524zm175.543-97.524h97.524v195.048h-97.524zm175.543-97.524h97.524v292.572H638.78z"}}),_c('path',{attrs:{"d":"M906.971 614.4V58.514H117.03v551.01H34.133V960.61H984.99V609.524h-78.019zM214.552 156.038h594.896v453.486H551.01v102.4h-82.896v-102.4H214.552V156.038zm677.79 711.924H131.658V711.924H370.59v19.505c0 48.761 39.01 82.895 82.896 82.895h112.152c43.886 0 82.895-39.01 82.895-82.895v-19.505h238.934v156.038z"}})])
          )
        }
      }
    